module.exports = __webpack_public_path__ + "static/media/password.ceed3db1.svg";